module.exports = __webpack_public_path__ + "static/media/starPilotAll.bf8fc0a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/starPilotAll.png
// module id = 189
// module chunks = 0